export const links = [
  {
    name: 'Home',
    path: '/',
    id: 'home',
  },
  {
    name: 'Join Us',
    path: '/joinus',
    id: 'joinus',
  },
  {
    name: 'Activities',
    path: '/activities',
    id: 'activities',
  },
  {
    name: 'Events',
    path: '/events',
    id: 'events',
  },
  {
    name: 'Shop',
    path: '/shop',
    id: 'shop',
  },
  {
    name: 'Committee',
    path: '/committee',
    id: 'committee',
  },
  {
    name: 'Contact Us',
    path: '/contact',
    id: 'contact',
  },
];
